import {
  AuxEngineReport,
  EngineReportFilter,
  MainEngineReport,
} from '@navstation-portal/reporting/data-model/engine-reports';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export interface EngineReports {
  meReports: MainEngineReport[];
  aeReports: AuxEngineReport[];
}

export interface ExtractEngineReportsPayload {
  vesselId: string;
  vesselName: string;
  reportFilter: EngineReportFilter;
}

export const engineReportsEvents = eventGroup({
  source: 'EngineReportsStore',
  events: {
    fetchEngineReports: type<string>(),
    fetchedEngineReports: type<EngineReports>(),
    extractEngineReports: type<ExtractEngineReportsPayload>(),
    extractEngineReportsSuccess: type<void>(),
    extractEngineReportsFailed: type<void>(),
    reset: type<void>(),
  },
});
